import React, { useState } from 'react';

import { Box } from '@material-ui/core';
import { connect } from 'react-redux';

import useDidMount from '~/hooks/use-did-mount';
import thunks from '~/redux/thunks';

import AppHeaderBar from './AppHeaderBar';
import styles from './AppLayout.module.scss';
import AppRoutes from './AppRoutes';
import AppSideMenu from './AppSideMenu';

export const LAYOUT_CONTAINER_ID = 'appLayout';

const AppLayout = ({ refreshUserAuthentication, history, skipRefreshToken }) => {
    const [ready, setReady] = useState(false);

    const navigateToLanding = () => {
        history.push('/');
    };

    const navigateToLogin = () => {
        history.push('/login');
    };

    const refreshToken = async () => {
        try {
            await refreshUserAuthentication();
            setReady(true);
        } catch (ex) {
            console.warn(ex);
            const { response } = ex;
            if (!response) {
                navigateToLanding();
            } else {
                navigateToLogin();
            }
        }
    };

    useDidMount(() => {
        if (!skipRefreshToken) {
            refreshToken();
        } else {
            setReady(true);
        }
    });

    if (!ready) {
        return 'Atualização autorização de acesso...';
    }

    return (
        <Box className={styles.container}>

            <AppSideMenu />

            <div id={LAYOUT_CONTAINER_ID} className={styles.content}>

                <AppHeaderBar />

                <AppRoutes />

            </div>
        </Box>
    );
};

const mapStateToProps = ({ skipRefreshToken }) => ({
    skipRefreshToken,
});

const mapDispatchToProps = {
    refreshUserAuthentication: thunks.user.refreshUserAuthentication,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppLayout);
